export default __webpack_public_path__ + "static/media/down-gray.aaa69a84.svg";